import { CanActivate } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { PermissionService } from '../services/permission.service';

export class HasPermissionGuard {
  static forPermission(feature: string, permission: string) {
    @Injectable({
      providedIn: 'root',
    })
    class PermissionCheck implements CanActivate {
      private readonly _permissionService = inject(PermissionService);

      canActivate(): boolean {
        return this._permissionService.hasPermission(feature, permission);
      }
    }

    return PermissionCheck;
  }

  static isAdmin() {
    @Injectable({
      providedIn: 'root',
    })
    class PermissionCheck implements CanActivate {
      private readonly _permissionService = inject(PermissionService);

      canActivate(): boolean {
        return this._permissionService.isAdmin();
      }
    }

    return PermissionCheck;
  }
}
